const action = 'TravelWithCaravan';

const attempt = () => {
  const result = {
    success: true
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { history } = party;

  history.add({ action, result }, context);

  return {};
};

const TravelWithCaravan = onDone => ({
  title: 'With Caravan',
  action,
  enabled: () => false, // TODO: Enable Caravan
  execute: context => {
    const result = attempt(context);
    executeSideEffects(context, result);

    onDone();

    return {};
  },
  tooltips: [['COMING SOON']]
});

export default TravelWithCaravan;
